import {
  formatCarrierLabel,
  normalizeTrackingCode,
  trackingUrlFromCarrier,
} from "./carrierUrl"

const hasTrackingCode = shippingData =>
  !!normalizeTrackingCode(shippingData?.tracking_code)

/**
 * Prefer the last active row with a tracking code (matches Shippable#shipping_data).
 */
export const pickActiveShippingData = (shippingDatas = []) => {
  const active = (shippingDatas || []).filter(
    sd => sd?.state === "active" && hasTrackingCode(sd)
  )
  if (!active.length) {
    return null
  }
  return active[active.length - 1]
}

const toTracking = shippingData => {
  if (!shippingData) {
    return null
  }
  const code = normalizeTrackingCode(shippingData.tracking_code)
  if (!code) {
    return null
  }
  const carrier = shippingData.carrier
  return {
    carrier,
    carrierLabel: formatCarrierLabel(carrier),
    code,
    url: trackingUrlFromCarrier(carrier, code),
  }
}

/**
 * Outbound: IU shipment SD, else earliest non-canceled order shipment
 * (prefer shipped_at present), matching ActionApprovals::StoreRecord.
 */
export const resolveOutboundTracking = barcode => {
  const iuShipment = barcode?.spree_inventory_unit?.shipment
  const fromIuShipment = toTracking(
    pickActiveShippingData(iuShipment?.shipping_datas)
  )
  if (fromIuShipment) {
    return fromIuShipment
  }

  const shipments = (barcode?.spree_order?.spree_shipments || []).filter(
    shipment => shipment?.state !== "canceled"
  )
  const shipped = shipments
    .filter(shipment => !!shipment?.shipped_at)
    .slice()
    .sort((a, b) => {
      const aTime = new Date(a.shipped_at).getTime()
      const bTime = new Date(b.shipped_at).getTime()
      return aTime - bTime
    })
  const chosen = shipped[0] || shipments[0]
  return toTracking(pickActiveShippingData(chosen?.shipping_datas))
}

/**
 * Inbound (return-to-lab): barcode SD first, else inventory-unit SD.
 */
export const resolveInboundTracking = barcode => {
  const fromBarcode = toTracking(pickActiveShippingData(barcode?.shipping_datas))
  if (fromBarcode) {
    return fromBarcode
  }
  return toTracking(
    pickActiveShippingData(barcode?.spree_inventory_unit?.shipping_datas)
  )
}
